'use strict';

var _classCallCheck = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Transform = require('stream').Transform;

var MessageJoiner =
/*#__PURE__*/
function (_Transform) {
  _inherits(MessageJoiner, _Transform);

  function MessageJoiner() {
    _classCallCheck(this, MessageJoiner);

    var options = {
      readableObjectMode: false,
      writableObjectMode: true
    };
    return _possibleConstructorReturn(this, _getPrototypeOf(MessageJoiner).call(this, options));
  }

  _createClass(MessageJoiner, [{
    key: "_transform",
    value: function _transform(obj, encoding, callback) {
      if (Buffer.isBuffer(obj)) {
        this.push(obj);
      } else if (obj.type === 'node') {
        this.push(obj.getHeaders());
      } else if (obj.value) {
        this.push(obj.value);
      }

      return callback();
    }
  }, {
    key: "_flush",
    value: function _flush(callback) {
      return callback();
    }
  }]);

  return MessageJoiner;
}(Transform);

module.exports = MessageJoiner;